"use client";
import { GridRowParams, GridActionsCellItem } from "@mui/x-data-grid-pro";
import {
  GetAvailableFormsDocument,
  AvailableFormsRow,
  // UpdateFormEnabledDocument,
} from "@quales/data-access/gql-server";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslations } from "next-intl";
import React from "react";
import { useRouter } from "next/navigation";
import { useQuery } from "@apollo/client";
import { useTheme } from "@quales/utils/theme";
import { WcStack } from "@bpipartners/webui";
import { WcGridColDef, WcDataGrid } from "@bpipartners/datagrid";
import { Header } from "../ui/header";
import { enqueueSnackbar } from "notistack";
import { useWindowDimensions } from "@quales/utils/hooks";

export const ViewFormOverviewComposite = () => {
  const {
    data: formData,
    loading: formLoading,
    refetch,
  } = useQuery(GetAvailableFormsDocument, {
    fetchPolicy: "network-only",
  });
  const theme = useTheme();
  const windowSize = useWindowDimensions();
  const t = useTranslations();
  const router = useRouter();

  const handleNavigateToFormBuilder = React.useCallback(
    (param: GridRowParams) => () => {
      window.open(
        `/formDesigner/${param.id}`,
        "_blank",
        `fullscreen=no,toolbar=no,titlebar=no,scrollbars=yes,menubar=no,resizable=no,top=200,left=250,width=${windowSize.width},height=${windowSize.height}`
      );
    },
    [windowSize.height, windowSize.width]
  );

  const handleOnUpdateCompleted = function () {
    setTimeout(() => {
      enqueueSnackbar(t("feedback.updateSuccess"), {
        variant: "success",
      });

      refetch();
    }, 1000);
  };

  // const [updateEnabled] = useMutation(UpdateFormEnabledDocument, {
  //   onCompleted: handleOnUpdateCompleted,
  // });

  // const handleUpdateEnabled = React.useCallback(
  //   (param: GridRowParams) => () => {
  //     updateEnabled({
  //       variables: {
  //         input: {
  //           enabled: !param.row.enabled,
  //           formID: param.row.formID,
  //         },
  //         customForm: param.row.customForm,
  //       },
  //     });
  //   },
  //   []
  // );
  const [formList, setFormList] = React.useState<AvailableFormsRow[]>([]);
  React.useEffect(() => {
    if (
      !formLoading &&
      formData &&
      formData.AvailableForms &&
      formData.AvailableForms.length > 0
    ) {
      setFormList(formData.AvailableForms);
    } else {
      setFormList([]);
    }
  }, [formData, formLoading]);

  const UserColumnData: WcGridColDef[] = [
    {
      field: "name",
      headerName: t("labels.name"),
      minWidth: 250,
      flex: 0.5,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: t("labels.description"),
      minWidth: 250,
      flex: 0.5,
      sortable: true,
      disableColumnMenu: true,
    },

    {
      field: "formVersion",
      headerName: t("labels.formVersion"),
      minWidth: 250,
      flex: 0.5,
      sortable: true,
      disableColumnMenu: true,
    },

    {
      field: "enabled",
      headerName: t("labels.enabled"),
      minWidth: 250,
      flex: 0.5,
      type: "boolean",
      sortable: true,
      disableColumnMenu: true,
    },

    {
      field: "actions",
      type: "actions",
      minWidth: 80,
      flex: 0.2,
      headerName: t("labels.actions"),
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          key={1}
          icon={<EditIcon color="primary" titleAccess={t("common.viewForm")} />}
          label={t("common.viewForm")}
          onClick={handleNavigateToFormBuilder(params)}
        />,
        <GridActionsCellItem
          key={2}
          icon={
            <FlipCameraAndroidIcon
              color="primary"
              titleAccess={t("common.changeState")}
            />
          }
          label={t("common.changeState")}
          // onClick={handleUpdateEnabled(params)}
        />,
      ],
    },
  ];

  return (
    <WcStack id="ViewFormOverviewComposite">
      <Header
        pageTitle={t("common.FormDesigner")}
        pageTitleTypographyProps={{
          variant: "h5",
          color: theme.appColors.primary,
        }}
      ></Header>
      <WcStack
        spacing={2}
        width={"100%"}
        height={windowSize.height - theme.dimensions.totalTopbarHeight}
      >
        {!formLoading && formList && (
          <WcDataGrid
            columns={UserColumnData}
            rowSelection={false}
            rowHeight={50}
            getCustomID={(row) => row.formID}
            rows={formList}
          />
        )}
      </WcStack>
    </WcStack>
  );
};

export default ViewFormOverviewComposite;
